import { useEffect, useState } from 'react'
import { sfxCountdown, unlockAudio } from '../gameslib/audio'

export function Countdown({ onDone }) {
  const [phase, setPhase] = useState('ready')

  useEffect(() => {
    let cancelled = false
    const steps = [
      { p: 'ready', ms: 650 },
      { p: 'set', ms: 650 },
      { p: 'go', ms: 450 },
    ]
    let i = 0
    let timer

    const tick = async () => {
      if (cancelled) return
      // Re-unlock right before each beep — iOS can suspend between delays
      await unlockAudio()
      if (cancelled) return
      const current = steps[i].p
      setPhase(current)
      void sfxCountdown(current)
      timer = window.setTimeout(() => {
        i += 1
        if (i >= steps.length) onDone()
        else void tick()
      }, steps[i].ms)
    }

    void (async () => {
      await unlockAudio()
      if (!cancelled) void tick()
    })()

    return () => {
      cancelled = true
      clearTimeout(timer)
    }
  }, [onDone])

  return (
    <div className="countdown">
      <span className="countdown__word" key={phase}>
        {phase}
      </span>
    </div>
  )
}

export function MemoryTimer({ seconds = 5, onDone, label = 'Seconds to remember' }) {
  const [left, setLeft] = useState(Math.round(seconds * 100))

  useEffect(() => {
    const start = performance.now()
    const total = seconds * 1000
    let raf = 0
    const loop = (t) => {
      const remain = Math.max(0, total - (t - start))
      setLeft(Math.round(remain / 10))
      if (remain <= 0) onDone()
      else raf = requestAnimationFrame(loop)
    }
    raf = requestAnimationFrame(loop)
    return () => cancelAnimationFrame(raf)
  }, [seconds, onDone])

  return (
    <div className="stimulus">
      <div className="memory-timer__num">{String(left).padStart(3, '0')}</div>
      <div className="memory-timer__label">{label}</div>
    </div>
  )
}
